export function graphqlMutationErrors(errors) {
  const errorMessages = errors.graphQLErrors.map(({ message }) => {
    const parsedError = JSON.parse(message);
    return parsedError.error || Object.values(parsedError.errors);
  });
  return errorMessages.join();
}
